var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.local)?_c(_vm.iconName,{tag:"component",staticClass:"svg-icon"}):(_vm.svg)?_c('svg',{class:_vm.svgClass,style:({'fill':_vm.color,transform: 'scale('+_vm.scale+')'}),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_c('i',{staticClass:"svg-icon",class:`${_vm.iconName}`})
}
var staticRenderFns = []

export { render, staticRenderFns }